
<template>
  <div
    class="trackingContainer viewContainer"
    :class="{ navBarActive: $store.state.navBar }"
  >
    <v-snackbar
      :color="snackbarColor"
      absolute
      top
      :timeout="3000"
      v-model="snackbar"
      >{{ snackbarText }}</v-snackbar
    >

    <Header
      :loading="loading"
      title="Puntos Permitidos"
      :showSearch="true"
      searchTitle="Buscar punto"
      @add="showAdd"
      :showNewButton="true"
    />

    <div class="main">
      <v-data-table
        :headers="headers"
        :items="points"
        :items-per-page="10"
        :loading="loading"
        sort-by="name"
        class="mt-5"
        :sort-desc="true"
        :search="searchTerm"
        item-key=".key"
        :footer-props="{
          itemsPerPageOptions: [10, 50, 100],
        }"
      >
        <template v-slot:[`item.active`]="{ item }">
          <v-switch
            @change="
              switchControlChanged({ active: item.active }, item['.key'])
            "
            :loading="loading"
            v-model="item.active"
          />
        </template>

        <template v-slot:[`item.createdAt`]="{ item }">
          {{ item.createdAt | filterDate }}
        </template>

        <template v-slot:[`item.address`]="{ item }">
          <a
            style="display: block; color: #FF1744"
            v-if="item.address && item.address.geopoint"
            :href="
              'https://www.google.com/maps/search/?api=1&query=' +
              item.address.geopoint.latitude +
              ',' +
              item.address.geopoint.longitude
            "
            target="_blank"
          >
            {{
              item.address.geopoint.latitude
                ? parseFloat(item.address.geopoint.latitude).toFixed(6) + ","
                : "no disponible"
            }}{{
              item.address.geopoint.longitude
                ? parseFloat(item.address.geopoint.longitude).toFixed(6)
                : ""
            }}
            <i class="ml-1 fas fa-external-link-alt"></i>
          </a>
        </template>
        <template v-slot:[`item.options`]="{ item }">
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn
                class="mx-1"
                fab
                :loading="loading"
                v-on="on"
                @click="editPoint(item)"
                :dark="$vuetify.theme.dark"
                x-small
                :elevation="0"
              >
                <v-icon color="primary" dark>fas fa-pencil</v-icon>
              </v-btn>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn
                :loading="loading"
                class="mx-1 ml-3"
                fab
                @click="showDelete(item)"
                v-on="on"
                :dark="$vuetify.theme.dark"
                x-small
                :elevation="0"
              >
                <v-icon color="red" dark>fas fa-trash</v-icon>
              </v-btn>
            </template>
            <span>Eliminar</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </div>

    <v-dialog max-width="800" persistent v-model="addDialog" v-if="addDialog">
      <add-item
        @success="success"
        :selectedItem="selectedItem"
        :businessId="user.businessID"
        @cancel="addDialog = false"
      />
    </v-dialog>

    <v-dialog
      max-width="500"
      persistent
      v-model="deleteDialog"
      v-if="deleteDialog"
    >
      <delete-d
        @confirm="deleteComfirmed"
        :name="selectedItem.name"
        :loading="loading"
        @cancel="deleteDialog = false"
      />
    </v-dialog>
  </div>
</template>

<script>
import { db } from "@/firebase";
import { mapActions, mapState } from "vuex";

import moment from "moment-timezone";
import "moment/locale/es";
import Header from "@/components/header.vue";
import deleteD from "@/components/delete.vue";

moment.locale("es");
import addItem from "./add-item";

export default {
  name: "Point",
  components: {
    addItem,
    Header,
    deleteD,
  },
  data() {
    return {
      business: {},
      points: [],
      loading: true,
      selectedItem: null,
      addDialog: false,
      deleteDialog: false,
      snackbarText: "",
      snackbarColor: "green darken-2",
      snackbar: false,
      headers: [
        {
          value: "name",
          text: "Nombre",
        },
        {
          value: "contactName",
          text: "Nombre del Contacto",
        },
        {
          value: "contactPhone",
          text: "Teléfono del Contacto",
        },
        {
          value: "address",
          text: "Ubicación",
        },
        {
          value: "active",
          text: "Activo",
        },
        {
          value: "createdAt",
          text: "Creado",
        },
        {
          value: "options",
          width: "200px",
          align: "end",
        },
      ],
    };
  },
  computed: {
    ...mapState(["user", "searchTerm"]),
  },
  filters: {
    filterDate(timestamp) {
      if (!timestamp) return "no disponible";
      return moment(timestamp.toDate())
        .tz("America/Tegucigalpa")
        .format("DD/MM/YYYY");
    },
  },
  methods: {
    ...mapActions(["updateSearchLabel", "showSearch", "showSearchMobileF"]),
    showAdd() {
      this.selectedItem = null;
      this.addDialog = true;
    },

    switchControlChanged(data, pointId) {
      if (data && pointId) {
        this.loading = true;
        db.collection("businessesCorporative")
          .doc(this.user.businessID)
          .collection("points")
          .doc(pointId)
          .update(data)
          .then(() => {
            this.snackbarText = "Punto actualizado exitosamente.";
            this.snackbar = true;
            this.snackbarColor = "green darken-2";
            this.loading = false;
          })
          .catch(() => {
            this.snackbarText =
              "Ocurrió un error inesperado, inténtelo nuevamente.";
            this.snackbar = true;
            this.snackbarColor = "red darken-2";
            this.loading = false;
          });
      }
    },

    deleteComfirmed() {
      this.loading = true;
      db.collection("businessesCorporative")
        .doc(this.user.businessID)
        .collection("points")
        .doc(this.selectedItem[".key"])
        .update({
          deleted: true,
          deletedBy: this.user[".key"],
          deletedAt: new Date(),
        })
        .then(() => {
          this.snackbarText = "Punto eliminado exitosamente.";
          this.snackbar = true;
          this.loading = false;
          this.snackbarColor = "green darken-2";
          this.deleteDialog = false;
        })
        .catch((e) => {
          this.snackbarText =
            "Ocurrió un error inesperado, inténtelo nuevamente.";
          this.snackbar = true;
          this.loading = false;
          this.snackbarColor = "red darken-2";
        });
    },

    showDelete(item) {
      this.selectedItem = item;
      this.deleteDialog = true;
    },
    editPoint(item) {
      this.selectedItem = item;
      this.addDialog = true;
    },
    success() {
      this.snackbarText = `${
        this.selectedItem
          ? "Punto editado correctamente."
          : "Punto agregado correctamente."
      }`;
      this.snackbarColor = "green darken-2";
      this.snackbar = true;
      this.addDialog = false;
    },
  },
  async mounted() {
    this.showSearch(true);
    this.updateSearchLabel("Buscar punto");
    this.$store.commit("setLoading", "Cargando...");
    this.showSearchMobileF(true);

    await this.$binding(
      "points",
      db
        .collection("businessesCorporative")
        .doc(this.user.businessID)
        .collection("points")
        .where("deleted", "==", false)
    );
    this.$store.commit("setLoading", "");
    this.$store.commit("setNavBar", true);
    this.loading = false;
  },
};
</script>
